import { gql } from '__generated__';

export default gql(`
  query GetSportTypes {
    sportTypes
  }
`);
